var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col page"},[_c('top'),_c('div',{staticClass:"flex-row"},[_c('leftMenus'),_c('right')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }